import { useIntl } from "react-intl";
import { IAddNewMinerProps } from "./AddNewMiner.props";
import styles from "./AddNewMiner.module.scss";
import cn from "classnames";
import { useAddNewMinerControl } from "./useAddNewMinerControl";
import { Button, Tooltip } from "antd";
import SettingsList from "./SettingsList/SettingsList";

export default function AddNewMiner({ ...props }: IAddNewMinerProps) {
  const { formatMessage } = useIntl();
  const control = useAddNewMinerControl(props);

  return (
    <div
      className={cn(styles.add_miner_wrapper, {
        [styles.inactive]: control.inactive,
      })}
    >
      <Tooltip
        placement="bottomLeft"
        open={control.hasClonedSetting ? undefined : false}
        trigger={"click"}
        color="#fff"
        title={<SettingsList list={control.savedSettings} />}
      >
        <Button
          type="primary"
          className={cn(styles.add_miner, {
            [styles.hasClonedSetting]: control.hasClonedSetting,
          })}
          onClick={!control.hasClonedSetting ? control.onAddMiner : undefined}
          loading={control.loading}
          title={formatMessage({ id: "machines.add_miner" })}
        >
          {/* {formatMessage({ id: "machines.add_miner" })} */}+
        </Button>
      </Tooltip>
    </div>
  );
}
